/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import { Button } from "@cd2/components/build/es6"
import React from "react"
import { IComponentProps } from "@cd2/tools/build/es6"

export function ConfirmCancelButtons({
  onConfirm,
  onCancel,
  buttonOpts,
  disabled,
  extraButtons,
  className,
}: {
  onConfirm: ((e: any) => void) | "submit"
  onCancel?(): void
  disabled?: boolean
  buttonOpts?: {
    confirm?: Partial<IComponentProps<typeof Button>>
    cancel?: Partial<IComponentProps<typeof Button>>
  }
  extraButtons?: IComponentProps<typeof Button>[]
  className?: string
}) {
  return (
    <div
      css={css`
        > * {
          margin-right: 8px;
        }
      `}
      className={className}
    >
      {typeof onConfirm === "string" ? (
        <Button
          children="Confirm"
          buttonProps={{ type: "submit" }}
          disabled={disabled}
          {...(buttonOpts?.confirm ?? {})}
        />
      ) : (
        <Button
          children="Confirm"
          onClick={onConfirm}
          disabled={disabled}
          {...(buttonOpts?.confirm ?? {})}
        />
      )}

      {extraButtons?.map(v => (
        <Button disabled={disabled} {...v} />
      ))}

      {onCancel && (
        <Button
          children="Cancel"
          onClick={onCancel}
          buttonColor="white"
          disabled={disabled}
          {...(buttonOpts?.cancel ?? {})}
        />
      )}
    </div>
  )
}
